<div class="input-group d-flex flex-nowrap date-picker-custom-class">
  <input
    [formControl]="formControl"
    [formlyAttributes]="field"
    [minDate]="minDate$ | async"
    [maxDate]="maxDate$ | async"
    [markDisabled]="markDateDisable$ | async"
    outsideDays="collapsed"
    navigation="arrows"
    class="form-control"
    [ngClass]="props.inputClass"
    name="dp"
    ngbDatepicker
    #d="ngbDatepicker"
    data-testing-id="date-picker"
    [attr.aria-label]="props.ariaLabel | translate"
    [attr.aria-required]="props.required ? 'true' : undefined"
    [attr.aria-invalid]="showError ? 'true' : undefined"
    [attr.aria-describedby]="props.ariaDescribedByIds"
  />

  <div class="input-group-append">
    <button
      (click)="d.toggle()"
      type="button"
      class="btn btn-secondary"
      title="{{ 'checkout.shipping.calendar.title' | translate }}"
      [disabled]="props.disabled"
      aria-haspopup="dialog"
      aria-expanded="false"
      data-testing-id="btn-date-picker"
    >
      <fa-icon class="text-primary" icon="calendar-day" />
    </button>
  </div>
</div>
